/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/Navs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Nav Reducers 
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Tuesday, September 18, 2018 - 9:30 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/18/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    NAV_LIST_CONTAINER_LOADED,
    NAV_LIST_CONTAINER_UNLOADED,

    NAV_LIST_TABLE_LOADED,
    NAV_LIST_TABLE_UNLOADED,

    NAV_LIST_CHANGE_NAVGROUP_SELECT,

    NAV_SELECT_ROW,
    NAV_ADD,
    NAV_EDIT,
    NAV_DELETE,
    NAV_DELETE_DISABLE,
    NAV_OPEN_WARNING,
    NAV_CLOSE_WARNING,
    NAV_VIEW_NAVS,


    NAV_EDIT_CONTAINER_LOADED,
    NAV_EDIT_CONTAINER_UNLOADED,

    NAV_EDIT_FORM_LOADED,
    NAV_EDIT_FORM_UNLOADED,
    NAV_EDIT_DATA_LOAD,
    NAV_EDIT_CONTAINER_CANCEL,

    NAV_EDIT_LOAD_NAVTYPE_SELECT,
    NAV_EDIT_DRAW_NAVTYPE_SELECT,
    NAV_EDIT_LOAD_COMPONENTGROUP_SELECT,
    NAV_EDIT_DRAW_COMPONENTGROUP_SELECT,
    NAV_EDIT_LOAD_COMPONENT_SELECT,
    NAV_EDIT_DRAW_COMPONENT_SELECT
} from '../constants/actionTypeNavs';

const defaultState = {
    refreshList: false,
    navgroups: [],
    navtypes: [],
    componentgroups: [],
    components: [],
    danger: false,
    navid: 0,
    navgroupid: 0,
    parentid: 0,
    name: '',
    description: '',
    navtypeid: 0,
    icon: '',
    componentgroupid: 0,
    componentid: 0,
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case NAV_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                navs: action.payload[0] ? action.payload[0].records : [],
                navgroups: action.payload[1] ? action.payload[1].navgroups : [],
                itempath: action.payload[2] ? action.payload[2].records : []
            }
        case NAV_LIST_CHANGE_NAVGROUP_SELECT:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                navs: action.payload[0] ? action.payload[0].records : [],
                itempath: action.payload[1] ? action.payload[1].records : []
            }
        case NAV_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case NAV_SELECT_ROW:
            return {
                ...state,
                navid: action.id
            }
        case NAV_ADD:
            return {
                ...state
            }
        case NAV_EDIT:
            return {
                ...state,
                navid: action.id
            }
        case NAV_DELETE:
            return {
                ...state,
                navid: null
            }
        case NAV_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case NAV_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case NAV_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case NAV_VIEW_NAVS:
            return {
                ...state
            }

        case NAV_EDIT_LOAD_NAVTYPE_SELECT:
            return {
                ...state,
                navtypes: action.payload ? action.payload.navtypes : []
            }
        case NAV_EDIT_DRAW_NAVTYPE_SELECT:
            return {
                ...state,
                navTypeOptions: action.payload ? action.payload : []
            }
        case NAV_EDIT_LOAD_COMPONENTGROUP_SELECT:
            return {
                ...state,
                componentgroups: action.payload ? action.payload.componentgroups : []
            }
        case NAV_EDIT_DRAW_COMPONENTGROUP_SELECT:
            return {
                ...state,
                componentGroupOptions: action.payload ? action.payload : []
            }
        case NAV_EDIT_LOAD_COMPONENT_SELECT:
            return {
                ...state,
                components: action.payload ? action.payload.records : []
            }
        case NAV_EDIT_DRAW_COMPONENT_SELECT:
            return {
                ...state,
                componentOptions: action.payload ? action.payload : [],
                componentDisabled: action.componentDisabled
            }

        case NAV_EDIT_CONTAINER_LOADED:
            return {
                ...state
            }
        case NAV_EDIT_DATA_LOAD:
            return {
                ...state,
                navid: action.payload ? action.payload.navid : 0,
                navgroupid: action.payload ? action.payload.navgroupid : 0,
                parentid: action.payload ? action.payload.parentid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                navtypeid: action.payload ? action.payload.navtypeid : 0,
                icon: action.payload ? action.payload.icon : '',
                componentgroupid: action.payload ? action.payload.componentgroupid : 0,
                componentid: action.payload ? action.payload.componentid : 0,
                orderid: action.payload ? action.payload.orderid : 0,
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case NAV_EDIT_FORM_LOADED:
            return {
                ...state
            }

        case NAV_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case NAV_LIST_CONTAINER_UNLOADED:
        case NAV_LIST_TABLE_UNLOADED:
        case NAV_EDIT_CONTAINER_UNLOADED:
        case NAV_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Navs.js